<template>
<div>
    <HeaderContent header="จัดการรูปภาพหน้าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentManageImage />
    <ContentManageImportCountryList />
</div>
</template>

<script>
import HeaderImage from '@/assets/picture.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentManageImage from '@/components/menuadmin/content/contentmanageimage/MenuContentManageImage.vue'
import ContentManageImportCountryList from '@/components/menuadmin/content/contentmanageimage/ContentManageImportCountryList.vue'

export default {
    name: 'contentManageImportCountry',
    components: {
        HeaderContent,
        MenuContentManageImage,
        ContentManageImportCountryList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
